export type OtpLookupRequestPayload = {
	familyName: string;
	phoneNumber: string;
	redirectTo?: string;
	facility?: string;
	timeSlot?: {
		date?: string | null;
		providerId?: string | null;
		time?: string | null;
	} | null;
	mainReasonForVisit?: unknown;
	specificReasons?: string;
};

export type OtpLookupApiResponse = {
	matched?: boolean;
	lookupToken?: string;
	email?: string;
	reason?: string;
};

export type OtpAuthenticationApiResponse = {
	token?: string;
	error?: string;
};

export const postOtpLookupRequest = async ({
	endpoint,
	payload,
	signal,
}: {
	endpoint: string;
	payload: OtpLookupRequestPayload;
	signal?: AbortSignal;
}) => {
	const response = await fetch(endpoint, {
		method: 'POST',
		signal,
		headers: {
			'content-type': 'application/json',
		},
		body: JSON.stringify({
			variables: {
				familyName: payload.familyName.trim(),
				phoneNumber: payload.phoneNumber,
				redirectTo: payload.redirectTo,
				facility: payload.facility,
				timeSlot: payload.timeSlot,
				mainReasonForVisit: payload.mainReasonForVisit,
				specificReasons: payload.specificReasons,
			},
		}),
	});

	const result = (await response.json()) as OtpLookupApiResponse;

	return { response, result };
};

export const postOtpAuthenticationRequest = async ({
	endpoint,
	body,
}: {
	endpoint: string;
	body: Record<string, string>;
}) => {
	const response = await fetch(endpoint, {
		method: 'POST',
		headers: {
			'content-type': 'application/json',
		},
		body: JSON.stringify(body),
	});

	const result = (await response.json()) as OtpAuthenticationApiResponse;

	return { response, result };
};
